<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/azOSuc/images/9781455528691.jpg?1733067611594" alt="This image is the cover for the book Taste of Sugar, Sugar, Georgia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Taste of Sugar, Sugar, Georgia
      </h1>
      <p class="bookDescription body article font2">
        <b>A blast from the past leads to tantalizing trouble for one woman in this dazzling second chance romance set in the small town of Sugar, Georgia. </b><br/><br/> Charlotte Holden, Sugar's favorite pediatrician, knows better than anyone that love only leads to heartbreak. Instead, she's focused on creating an outpatient center for children. All she has to do now is win over a big-city donor–easy as peach pie. Then sexy Jace McGraw blows back into town and utters those three words every woman dreads: we're still married. <br/><br/> Jace McGraw was making an offer on his dream business in Atlanta when he was told that his wife had some credit issues. The annulment went through years ago—or so he thought. He'd walked away only to keep his troublemaker reputation from ruining her dreams. <br/><br/> Now that they have a second chance, Jace offers Charlotte a deal: he'll grant a discreet divorce–in exchange for 30 days and nights of marriage–because this time he isn't going to let her go without a fight.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marina Adair
      </h2>
      
      <p class="authorDescription body article"><B>Marina Adair</B> is a #1 national bestselling author of romance novels and holds a Master of Fine Arts in creative writing. Along with the Destiny Bay series, she is also the author of the Sugar, Georgia series, the St. Helena Vineyard series, and her new Heroes of St. Helena series. She currently lives with her husband, daughter, and two neurotic cats in Northern California.<br><br> As a writer, Marina is devoted to giving her readers contemporary romance where the towns are small, the personalities large, and the romance explosive. She also loves to interact with readers and you can catch her on Twitter at @MarinaEAdair or visit her at www.MarinaAdair.com. Keep up with Marina by signing up for her newsletter at www.MarinaAdair.com/newsletter.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Forever
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ff41576